import {
  Avatar,
  colors,
  Box,
  Typography,
  styled,
  Card,
  type CardProps,
} from '@mui/material';
import { Link } from '~/components/Link';
import { ReportImage } from '~/components/ReportImage';
import React from 'react';
interface ReportCardProps extends CardProps {
  href: string;
  name: string;
  uuid: string;
  category: string;
  description?: string;
  footer: React.ReactNode;
}
export const ReportCard = ({
  href,
  name,
  uuid,
  category,
  description,
  footer,
}: ReportCardProps) => {
  return (
    <Card
      href={href}
      key={name}
      component={(props) => (
        <StyledLink {...props} underline="none" hideExternalIcon />
      )}>
      <ReportCardTop>
        <Avatar variant="square" sx={{ backgroundColor: colors.grey[100] }}>
          <ReportImage uuid={uuid} width={36} height={36} />
        </Avatar>
        <ReportCategory>{category}</ReportCategory>
      </ReportCardTop>
      <ReportTitle>{name}</ReportTitle>
      {description && <ReportDescription>{description}</ReportDescription>}
      <ReportCardFoot>
        <ReportResults>{footer}</ReportResults>
        <ReportArrow className="report-arrow">→</ReportArrow>
      </ReportCardFoot>
    </Card>
  );
};

const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background: #fff;
  border: 1px solid ${colors.grey[200]};
  border-radius: 14px;
  text-decoration: none;
  color: inherit;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    border-color 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px -8px rgba(15, 23, 42, 0.1);
    border-color: ${colors.grey[300]};
  }

  &:hover .report-arrow {
    transform: translateX(3px);
  }
`;

const ReportCardTop = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ReportCategory = styled(Typography)`
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${colors.grey[400]};
` as typeof Typography;

const ReportTitle = styled(Typography)`
  text-align: left;
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.grey[900]};
` as typeof Typography;

const ReportDescription = styled(Typography)`
  display: block;
  font-size: 13.5px;
  color: ${colors.grey[600]};
  line-height: 1.45;
  flex: 1;
` as typeof Typography;

const ReportCardFoot = styled(Box)`
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid ${colors.grey[100]};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ReportResults = styled(Typography)`
  font-size: 13px;
  color: ${colors.grey[600]};

  strong {
    color: ${colors.grey[900]};
    font-weight: 600;
  }
` as typeof Typography;

const ReportArrow = styled(Typography)`
  color: ${colors.blue[600]};
  font-size: 16px;
  transition: transform 0.15s;
  padding-left: 12px;
` as typeof Typography;
